<template>
    <ProductCard @click="bookingLesson">
		<ProductImage :src="item.image" :alt="item.title" />
		<ProductDescription :title="item.title" :description="item.description" :tags="item.tags" />
		<ProductFooter>
            <ProductPrice :price="item.price" :compareAt="item.compareAt" :deliveryFee="item.deliveryFee" />
        </ProductFooter>
    </ProductCard>
  
</template>

<script setup>
    import ProductFooter from './product/footerWrapper.vue'
    import ProductCard from './product/cardWrapper.vue'
	import ProductDescription from './product/description.vue'
	import ProductPrice from './product/price.vue'
	import ProductImage from './product/image.vue'
    import {useWebShopStore} from './webshopState'
    const webShopState = useWebShopStore()

	const {item} = defineProps({
		item: { type: Object, required: true },
	})

    const bookingLesson = () => {
        const baseUrl = webShopState.domain ? `https://${webShopState.domain}` : window.location.origin;
        window.location.href = `${baseUrl}/kalender?ref=1&product=${item.productId}&category=${item.categoryId}`;
    }
</script>

<style scoped>
</style>
